// extracted by mini-css-extract-plugin
module.exports = {"answers":"questions_answers__2_v7A","error":"questions_error__3RDBj","question":"questions_question__cltMH"};